<template>
  <p
    class="text-center tracking-widest text-xs font-bold xl:col-span-2 mb-3 uppercase font-bold"
  >
    <slot />
  </p>
</template>

<script>
export default {
  name: 'Alert',
};
</script>
